import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { IntraCompanyQueryKey } from './queryKey';
import { removeInfiniteDataItem } from '@/shared/utils/infiniteDataHelper';
const useRemoveDetailRow = () => {
    const queryClient = useQueryClient();
    const removeDetailRow = useCallback((detail) => {
        queryClient.setQueryData([IntraCompanyQueryKey.Details, detail.relationCompanyId, detail.userCompanyId], (oldData) => {
            return removeInfiniteDataItem(oldData, x => x.registrationId === detail.registrationId);
        });
    }, [queryClient]);
    return { removeDetailRow };
};
export default useRemoveDetailRow;
